<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="config().backgroundColor"
>
  <div class="left-side">
    <p
      class="completed-msg"
      [style.color]="config().completedMsg.color"
      [style.fontFamily]="config().completedMsg.fontFamily"
    >
      {{ config().completedMsg.text }}
    </p>

    @let rewardAmount = config().rewardAmount;
    @if (rewardAmount) {
      <div
        class="reward-amount"
        [style.color]="rewardAmount.color"
        [style.fontFamily]="rewardAmount.fontFamily"
        [style.backgroundColor]="rewardAmount.backgroundColor"
      >
        <span [innerHTML]="amount() | formatReward | safe"></span>
        {{ rewardAmount.text }}
      </div>
    }

    <p
      class="reward-msg"
      [style.color]="config().rewardProcessingMessage.color"
      [style.fontFamily]="config().rewardProcessingMessage.fontFamily"
    >
      {{ config().rewardProcessingMessage.text }}
    </p>
  </div>

  @let right = config().right;
  @if (right) {
    <div class="right-side">
      <img
        [ngSrc]="right.backgroundImage.imageUrl"
        [alt]="right.backgroundImage.alternativeText | replaceVars: amount()"
        width="85"
        height="85"
      />
      <div class="reward-content">
        <p
          class="reward-label"
          [style.color]="right.label.color"
          [style.fontFamily]="right.label.fontFamily"
          [style.fontSize]="right.label.fontSize"
        >
          {{ right.label.text }}
        </p>
        <p
          class="amount"
          [style.color]="right.amount.color"
          [style.fontFamily]="right.amount.fontFamily"
          [style.fontSize]="right.amount.fontSize"
        >
          {{ amount() | formatReward }}
        </p>
      </div>
    </div>
  }
</div>
